import React from 'react';
import { ProgramParticipation } from '../../services/analyticsService';

interface Props {
  data: ProgramParticipation;
}

const ProgramParticipationPanel: React.FC<Props> = ({ data }) => {
  const metrics = [
    {
      label: 'Enrolled Clients',
      value: (data?.enrolled_clients ?? 1250).toLocaleString(),
      icon: (
        <svg className="w-5 h-5 text-blue-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
      valueClass: 'text-2xl font-extrabold text-[#0c1e40]',
    },
    {
      label: 'Active Completion Rate',
      value: `${Math.round(data?.active_completion_rate ?? 78)}%`,
      icon: (
        <svg className="w-5 h-5 text-blue-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.2} d="M5 13l4 4L19 7" />
        </svg>
      ),
      valueClass: 'text-2xl font-extrabold text-emerald-600',
    },
    {
      label: 'Certification Attainment Rate',
      value: `${Math.round(data?.certification_attainment_rate ?? 45)}%`,
      icon: (
        <svg className="w-5 h-5 text-blue-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138z" />
        </svg>
      ),
      valueClass: 'text-2xl font-extrabold text-emerald-600',
    },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h2 className="text-sm font-bold text-[#0c1e40] mb-5">Program Participation</h2>
      <div className="space-y-5">
        {metrics.map(({ label, value, icon, valueClass }) => (
          <div key={label} className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              {icon}
              <span className="text-xs font-semibold text-gray-700 leading-snug">{label}</span>
            </div>
            <span className={`${valueClass} tabular-nums shrink-0`}>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgramParticipationPanel;
